import { Base2Presenter } from "core/presenter";
import { StockOperationsRepository } from "core/repository";

export default class HistoryGraphPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: true,
      results: [],
      format: "day"
    };
  }

  constructor(props) {
    super(props);
    this.filters = { dateFrom: null, dateTo: null, productUuid: null };
    this.loadCount = 0;
    this.currentLoading = Promise.resolve(true);
  }

  async onStart() {
    this.load();
  }

  async load() {
    this.enqueue({ loading: true });

    this.loadCount++;
    this.currentLoading = this.currentLoading.then(() => this.reloadData());
    await this.currentLoading;
    this.loadCount--;

    if (this.loadCount === 0) {
      this.enqueue({ loading: false });
    }
  }

  async reloadData() {
    const { filters } = this.props;
    const { dateFrom, dateTo, product } = filters;

    const interval = this.getInterval(dateFrom, dateTo);
    const result = await StockOperationsRepository.graph(
      product.uuid,
      dateFrom,
      dateTo,
      interval
    );

    if (result.success && this.loadCount === 1) {
      this.enqueue({
        results: result.data,
        format: interval
      });
    }
  }

  getInterval(dateFrom, dateTo) {
    if (dateTo.diff(dateFrom, "hours") <= 23) {
      return "hours";
    } else if (dateTo.diff(dateFrom, "month") === 0) {
      return "day";
    } else if (dateTo.diff(dateFrom, "day") <= 90) {
      return "week";
    } else if (dateTo.diff(dateFrom, "year") === 0) {
      return "month";
    } else {
      return "year";
    }
  }

  onChangeProps() {
    const { filters } = this.props;
    const { dateFrom, dateTo, product } = filters;
    if (
      dateFrom !== this.filters.dateFrom ||
      dateTo !== this.filters.dateTo ||
      product.uuid !== this.filters.productUuid
    ) {
      this.filters = {
        dateFrom,
        dateTo,
        productUuid: product.uuid
      };
      this.load();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/history/stock-entry-reports/history-graph/presenter.js